__turbopack_context__.v({
  "jobDetailVideo": "t0s-Ia_jobDetailVideo",
});
